import { Resources } from 'constants/resources';

import { green } from '@mui/material/colors';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Link } from 'react-router-dom';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { formatInputInTz } from 'utils/date';

type Props = {
  createdAt: number;
  requestId: string;
};

export const NotificationPopperListItemOrderSecondary: React.FC<Props> = ({
  createdAt,
  requestId,
}) => {
  const { createPathWithQuery } = useCreatePathWithQuery();
  const translate = useTypedTranslate();

  const to = createPathWithQuery(
    { resource: Resources.OrderAdjustmentsReport, type: 'list' },
    {
      filter: {
        requestId,
      },
    },
  );

  return (
    <>
      <Stack flexDirection="row" gap={1}>
        <Typography>{formatInputInTz(createdAt, { format: 'dd.MM.yyyy HH:mm' })}</Typography>
        <Typography>&bull;</Typography>
        <Link style={{ color: green[800] }} target="_blank" to={to}>
          <Typography>{translate('app.notificationPopper.ordersAdjustmentReport')}</Typography>
        </Link>
      </Stack>
    </>
  );
};
